const localeIsoEnum = Object.freeze({
  "da-DK": "da-DK",
  "fr-BE": "fr-BE",
  "fr-FR": "fr-FR",
  "nl-BE": "nl-BE",
  "nl-NL": "nl-NL",
  "sv-SE": "sv-SE",
} as const);
type LocaleIso = (typeof localeIsoEnum)[keyof typeof localeIsoEnum];

/** Our own locale format, it reverses the ISO locale format */
const localeMorpheusEnum = Object.freeze({
  "be-FR": "be-FR",
  "be-NL": "be-NL",
  "dk-DA": "dk-DA",
  "fr-FR": "fr-FR",
  "nl-NL": "nl-NL",
  "se-SV": "se-SV",
} as const);
type LocaleMorpheus =
  (typeof localeMorpheusEnum)[keyof typeof localeMorpheusEnum];

const localeCountryEnum = Object.freeze({
  BE: "BE",
  DK: "DK",
  FR: "FR",
  NL: "NL",
  SE: "SE",
} as const);
type LocaleCountry = (typeof localeCountryEnum)[keyof typeof localeCountryEnum];

const localeLanguageEnum = Object.freeze({
  da: "da",
  fr: "fr",
  nl: "nl",
  sv: "sv",
} as const);
type LocaleLanguage =
  (typeof localeLanguageEnum)[keyof typeof localeLanguageEnum];

export {
  localeCountryEnum,
  localeIsoEnum,
  localeLanguageEnum,
  localeMorpheusEnum,
};

export type { LocaleCountry, LocaleIso, LocaleLanguage, LocaleMorpheus };
